import * as React from "react";
import {
  MenuItem,
  MenuList,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
} from "@mui/material";
import {
  GridColumnMenuProps,
  useGridApiContext,
  useGridSelector,
  gridSortModelSelector,
  GridSortModel,
} from "@mui/x-data-grid";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SortIcon from "@mui/icons-material/Sort";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

type Props = GridColumnMenuProps;

export default function CustomColumnMenu(props: Props) {
  const { hideMenu, colDef } = props;
  const apiRef = useGridApiContext();
  const sortModel = useGridSelector(apiRef, gridSortModelSelector) as GridSortModel;

  const field = colDef.field;
  const canSort = colDef.sortable !== false;
  const canHide = colDef.hideable !== false;

  const currentSort = sortModel.find((s) => s.field === field)?.sort ?? null;

  const sortAsc = (e: React.MouseEvent<HTMLElement>) => {
    apiRef.current.sortColumn(field, "asc");
    hideMenu?.(e);
  };

  const sortDesc = (e: React.MouseEvent<HTMLElement>) => {
    apiRef.current.sortColumn(field, "desc");
    hideMenu?.(e);
  };

  const clearSort = (e: React.MouseEvent<HTMLElement>) => {
    const next = sortModel.filter((s) => s.field !== field);
    apiRef.current.setSortModel(next);
    hideMenu?.(e);
  };

  const hideColumn = (e: React.MouseEvent<HTMLElement>) => {
    apiRef.current.setColumnVisibility(field, false);
    hideMenu?.(e);
  };

  return (
    <Box>
      <MenuList autoFocusItem dense sx={{ py: 0.5, minWidth: 220 }}>
        <MenuItem onClick={sortAsc} disabled={!canSort || currentSort === "asc"}>
          <ListItemIcon>
            <ArrowUpwardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sort Ascending</ListItemText>
        </MenuItem>

        <MenuItem onClick={sortDesc} disabled={!canSort || currentSort === "desc"}>
          <ListItemIcon>
            <ArrowDownwardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sort Descending</ListItemText>
        </MenuItem>

        <MenuItem onClick={clearSort} disabled={!canSort || !currentSort}>
          <ListItemIcon>
            <SortIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Clear Sort</ListItemText>
        </MenuItem>

        <Divider />

        <MenuItem onClick={hideColumn} disabled={!canHide}>
          <ListItemIcon>
            <VisibilityOffIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Hide Column</ListItemText>
        </MenuItem>
      </MenuList>
    </Box>
  );
}
